//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUploader from '../../../common-components/file-uploader';

export default {
    name: 'delivery-otherOwner',
    components: { fileUploader },
    props: {
        recordId: {
            required: true,
            type: Number
        }
    },
    data() {
        return {
            otherOwnerList: [],
            columns: [
                { type: 'index', align: 'center', width: 60 },
                { title: '姓名', align: 'center', key: 'name' },
                { title: '手机号', align: 'center', key: 'phoneNumber' },
                { title: '证件类型', align: 'center', key: 'cardTypeStr' },
                { title: '证件号', align: 'center', key: 'cardNum' }
            ]
        };
    },
    methods: {
        getOtherOwner() {
            const vm = this;
            abp.ajax.get('/api/services/app/DeliveryRecord/GetOtherOwnerByRecordId?recordId=' + this.recordId).then(res => {
                this.otherOwnerList = [];
                this.otherOwnerList.push(...res.data.result);
            });
        }
    },
    created() {
        this.getOtherOwner();
    }
};
